import {
  ErrorComponentsState,
  ExtensionErrorInfoProps,
  LoadingErrorInfoProps,
  PageErrorInfoProps,
  UnknownErrorInfoProps,
} from "piral-core";
import * as React from "react";
import { ErrorComponent } from "./ErrorComponent";

export const errors: Partial<ErrorComponentsState> = {
  not_found: () => (
    <ErrorComponent
      title="We can't find that page"
      description={
        "Sorry, the page you are looking for doesn't exist or has been moved."
      }
      hideDebugInfo={true}
      homeOnly={true}
    />
  ),
  loading: (p: LoadingErrorInfoProps) => (
    <ErrorComponent
      title="Loading Error"
      error={{ message: p.error?.message ?? "", stack: p.error?.stack }}
    />
  ),
  page: (p: PageErrorInfoProps) => (
    <ErrorComponent
      title="Page Error"
      error={{ message: p.error?.message ?? "", stack: p.error?.stack }}
    />
  ),
  extension: (p: ExtensionErrorInfoProps) => (
    <ErrorComponent
      title="Extension Error"
      error={{ message: p.error?.message ?? "", stack: p.error?.stack }}
    />
  ),
  unknown: (p: UnknownErrorInfoProps) => (
    <ErrorComponent
      title="Unknown Error"
      error={{ message: p.error?.message ?? "", stack: p.error?.stack }}
    />
  ),
};

/** B2C error AADB2C90157 – user exceeded retry limit */
export const TooManyAttemptsError = () => (
  <ErrorComponent
    title="Too many attempts"
    description="You tried too often. Please wait a few minutes and try again."
    hideDebugInfo={true}
  />
);
